<template>
  <div class="kr-layout-content">
    <div class="content-left">
      <!--城市列表-->
      <div class="all-city">
        <ul class="city-list">
          <!-- <li :class=" {'active': n == 0} " @click="trans(-1,null)">最新</li> -->
          <li
            :class=" {'active': n == index} "
            v-for="(item,index) in List"
            :key="index"
            v-if="item.categoryName !='档案馆'"
            @click="trans(index,item.id)"
          >{{item.categoryName}}</li>
        </ul>
      </div>

      <!--文章信息-->
      <div class="new-article">
        <!--列表-->
        <ul class="art-list">
          <li v-for="(item,index) in artical" :key="index" @click="details(item.id)">
            <div class="head-img">
              <img :src="item.pic" alt />
            </div>
            <div class="content">
              <div class="title">
                <!-- <span>{{item.articleCategory}}</span> -->
                <p class="twoline">{{item.title}}</p>
              </div>
              <!-- <p class="intro twoline">{{item.subTitle}}</p> -->
              <div class="author">
                <div class="author-img">
                  <img :src="item.userHeadPic" alt />
                </div>
                <p class="name">
                  <!-- 来自主题：其他
                  <span class="line"></span>-->
                  作者：{{item.userName}}
                </p>
              </div>
            </div>
          </li>
        </ul>
        <div v-if="loadmore" class="look-more" @click="newsMore">查看更多</div>
        <p v-if="!loadmore" class="none-more">没有更多了</p>
      </div>
    </div>
    <!--右边-->
    <!-- 热门文章作者 -->
    <div class="content-right">
      <div class="top-img">
        <img src="../../assets/img/msg.png" alt />热门文章作者
      </div>
      <ul class="author-list">
        <li v-for="(item,index) in media" :key="index" @click="author(item.id)">
          <div class="author-img">
            <img :src="item.pic" />
          </div>
          <div class="cont">
            <p class="nick">{{item.nickName}}</p>
            <p class="email">{{item.des}}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
var setId = "";
export default {
  //   name: "App",
  data() {
    return {
      List: [],
      isFirst: true,
      artical: [],
      media: [],
      keyWord: "",
      loadmore: true,
      curPage: 1,
      totalPage: 0,
      curPage: 1
    };
  },
  computed: {
    n() {
      return this.$store.state.navigaterLevel2Index;
    },
    id() {
      return this.$store.state.navigaterLevel2Id;
    }
  },
  watch: {
    id() {
      this.curPage = 1;
      this.artical = [];
      this.loadmore = true;
      this.getData();
    }
  },
  methods: {
    getList() {
      //获取推荐信息
      this.$http
        .get("/api/core/001--CusCategoryList", {
          params: {
            type: 1
          }
        })
        .then(res => {
          // console.log(res, "分类列表");
          if (res.status == 200 && res.data.code == 0) {
            this.List = res.data.rows;
            // this.getData(res.data.rows[0].id)
          }
        });
    },
    getData() {
      //获取最新文章
      console.log(this.id);
      this.$http
        .get("/api/core/002--newsList", {
          params: {
            articleCategory: this.id,
            type: 1,
            pageNo: this.curPage
          }
        })
        .then(res => {
          // console.log(res, "最新文章");
          if (res.status == 200 && res.data.code == 0) {
            this.artical = this.artical.concat(res.data.rows);
            this.totalPage = res.data.totalPage;
            if (this.curPage >= this.totalPage) {
              this.loadmore = false;
            }
          }
        });
    },
    newsMore() {
      //查看更多
      this.curPage++;
      this.getData();
    },
    trans(i, id) {
      if(id == 8){
        id = null
      }
      this.$store.commit("setIndexId", { index: i, id: id });
    },
    getMedia() {
      //热门作者
      this.$http
        .get("/api/core/019-hotAuthor", {
          params: {
            type: 1,
            limit: 10
          }
        })
        .then(res => {
          console.log(res, "热门作者");
          if (res.status == 200 && res.data.code == 0) {
            this.media = res.data.rows;
          }
        });
    },
    details(id) {
      //图文详情
      this.$router.push({ path: "/ghDetails", query: { id: id, type: 1 } });
    },
    author(id) {
      //作者个人主页
      this.$router.push({ path: "/personal", query: { id: id, type: 3 } });
    }
  },
  mounted() {
    this.getList();
    this.getData();
    this.getMedia();
  }
};
</script>
<style scoped>
.new-article .art-list > li .content .author .author-img {
  margin-right: 10px;
}
.new-article .art-list {
  width: 99%;
}
.top-img {
  margin-top: 0px;
}
.all-city {
  margin-bottom: 20px;
}
.all-city .city-list {
  border: none;
  width: 100%;
}
</style>